import axios from "axios";
import { useAuthStore } from "../stores/auth";

// 接口基址固定为线上域名（开发、生产都走这个），避免环境变量带来的困扰。
const baseURL = "https://www.czymf-tool.cn";

export const http = axios.create({
  baseURL,
  timeout: 15000,
});

// 自动给 /api/admin/* 带上 admin_token（query）
http.interceptors.request.use((config) => {
  const auth = useAuthStore();
  const url = config.url || "";
  if (auth.adminToken && url.startsWith("/api/admin/")) {
    config.params = { ...(config.params || {}), admin_token: auth.adminToken };
  }
  return config;
});
